import { IconButton } from '@mui/material';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import { MouseEvent, ReactElement } from 'react';
import { useForm } from 'react-hook-form';

import { useStoreState } from '~/store/hooks';
import { IResolveCrisisCallPayload } from '~/services/api/crisis/types';
import Checkbox from '~/ui/components/inputs/Checkbox';
import Input from '~/ui/components/inputs/Input';

import styles from './CrisisResolveCheckbox.module.scss';

interface IProps {
  resolveCrisisCall?: (data: IResolveCrisisCallPayload) => Promise<unknown>;
  crisisCallId: number | null;
  tab: number;
}

const CrisisResolveCheckbox = ({ resolveCrisisCall, crisisCallId, tab }: IProps): ReactElement => {
  const { current: clinic } = useStoreState(state => state.clinic);

  const {
    control,
    register,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      markCrisisResolved: false,
      memo: '',
    },
  });

  const [isCrisisResolved, memo] = watch(['markCrisisResolved', 'memo']);

  const handleAddMemo = async (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    resolveCrisisCall?.({
      clinicId: clinic.id,
      crisisCallId,
      tab,
      memo,
    });
  };

  return (
    <div className={styles.markCrisisResolvedCheckbox}>
      <Checkbox
        size="small"
        name="markCrisisResolved"
        control={control}
        errors={errors}
        label="Mark Crisis Resolved"
      />
      {isCrisisResolved && (
        <div className={styles.memoInputContainer}>
          <Input
            register={register}
            errors={errors}
            name="memo"
            label="Add Memo"
            size="small"
            placeholder="Add a memo for crisis allocations"
            className={styles.memoInput}
          />
          <IconButton onClick={handleAddMemo} size="small">
            <AddBoxOutlinedIcon className={styles.addMemoButton} />
          </IconButton>
        </div>
      )}
    </div>
  );
};

export default CrisisResolveCheckbox;
